@if (!isDesktop) {
    <aa-app-advertisement type="the-aa-header-mobile"></aa-app-advertisement>
}
<header class="mb-3">
  <div class="app-header-container">
    <div class="app-header-content">
      <a class="app-header-logo" href="https://www.theaa.com/"></a>
      <h1>{{ this._appUtilityService.pageTitle }}</h1>
    </div>
    @if (isDesktop) {
      <aa-app-advertisement type="the-aa-leaderboard"></aa-app-advertisement>
    }

    <div class="mobileShow">
      <div id="overlay">
        <div class="menu_wrapper">
          <ul id="menu">
            <li><a href="https://www.theaa.com/breakdown-cover/">Breakdown cover</a></li>
            <li>
              <a href="https://www.theaa.com/breakdown-cover/european/">European breakdown cover</a>
            </li>
            <li>
              <a href="https://www.theaa.com/car-insurance/">Car insurance</a>
            </li>
            <li><a href="https://www.theaa.com/home-insurance/">Home insurance</a></li>
            <li><a href="https://www.theaa.com/finance/">Money</a></li>
            <li><a href="https://www.theaa.com/driving-school/driving-lessons/">Driving lessons</a></li>

            <li><a href="https://auth.theaa.com/auth/XUI/#login">Your account</a></li>
            <li><a href="https://www.theaa.com/help-support/contact-us">Help</a></li>
          </ul>

          <a class="home-menu" (click)="goToRoutePlanner()" (keyup.enter)="goToRoutePlanner()" tabindex="0">
            Go to the Route planner
          </a>
          </div>
        </div>
        <button id="button1" (click)="SwitchButtons('button1')" class="navButton">
          Menu
          <span class="toggleIcon"></span>
        </button>
        <button id="button2" (click)="SwitchButtons('button2')" class="navButton2" style="display: none">
          Close
          <span class="closeIcon"></span>
        </button>
      </div>
    </div>
    <div class="header-menu">
      <div class="content-wrapper">
        <ul>
          <li><a href="https://www.theaa.com/breakdown-cover/">Breakdown cover</a></li>
          <li><a href="https://www.theaa.com/insurance/">Insurance</a></li>
          <li><a href="https://www.theaa.com/travel">Travel</a></li>
        </ul>
      </div>
    </div>
  </header>
